var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('span',[_vm._v(_vm._s(_vm.prefix)+" "+_vm._s(_vm._f("plural")(_vm.humanDifference,_vm.humanWord, _vm.lang))+" "+_vm._s(_vm.suffix))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }